import { Component, OnDestroy, OnInit } from '@angular/core';
import { SubSink } from 'subsink';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

// --- PrimeNG ---
import {
	DialogService,
	DynamicDialogConfig,
	DynamicDialogRef,
} from 'primeng/dynamicdialog';

// --- Interfaces ---
import type { IVersion } from '@interfaces/version';

@Component({
	selector: 'app-version-dialog',
	templateUrl: './version-dialog.component.html',
	styleUrls: ['./version-dialog.component.scss'],
})
export class VersionDialog implements OnInit, OnDestroy {
	private subs = new SubSink();
	public safeDescription!: SafeHtml;

	constructor(
		public _ref: DynamicDialogRef,
		public _config: DynamicDialogConfig,
		public _dialogService: DialogService,
		private _sanitizer: DomSanitizer
	) {}

	get dialogData() {
		return this._config.data.version as IVersion;
	}

	ngOnInit(): void {
		const htmlOriginal = this.dialogData.description || '';
		const htmlCorrigido = this.corrigirListasQuill(htmlOriginal);

		this.safeDescription =
			this._sanitizer.bypassSecurityTrustHtml(htmlCorrigido);
	}

	onClose() {
		this._ref.close();
	}

	ngOnDestroy(): void {
		this.subs.unsubscribe();
	}

	private corrigirListasQuill(html: string): string {
		html = html.replace(/<ol>(.*?)<\/ol>/gs, (match, inner) => {
			const temBullet = /<li[^>]*data-list="bullet"[^>]*>/.test(inner);
			const temOrdered = /<li[^>]*data-list="ordered"[^>]*>/.test(inner);
			if (temBullet && !temOrdered) {
				return `<ul>${inner}</ul>`;
			}
			return match;
		});

		html = html.replace(/<ul>(.*?)<\/ul>/gs, (match, inner) => {
			const temOrdered = /<li[^>]*data-list="ordered"[^>]*>/.test(inner);
			if (temOrdered) {
				return `<ol>${inner}</ol>`;
			}
			return match;
		});

		html = html.replace(
			/<span class="ql-font-monospace">(.*?)<\/span>/gs,
			'<span style="font-family: monospace;">$1</span>'
		);

		html = html.replace(
			/<span class="ql-font-serif">(.*?)<\/span>/gs,
			'<span style="font-family: serif;">$1</span>'
		);

		return html;
	}
}
